import { useQuery } from '@tanstack/react-query';
import { fetchServiceStatus } from '../api/serviceStatus';

export function useServiceStatus(options = {}) {
  return useQuery({
    queryKey: ['service-status'],
    queryFn: fetchServiceStatus,
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    ...options,
  });
}
